module.exports = __webpack_public_path__ + "2c96be2055c6593608f90be016344cd7.ttf";